import * as React from "react";
import { styled, alpha } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import EditIcon from "@mui/icons-material/Edit";
import Divider from "@mui/material/Divider";
import ArchiveIcon from "@mui/icons-material/Archive";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import FiberNewOutlinedIcon from "@mui/icons-material/FiberNewOutlined";
import { useEffect } from "react";

import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import NativeSelect from "@mui/material/NativeSelect";
import InputBase from "@mui/material/InputBase";

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color: "var(--neutral-900)",
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
      backgroundColor: "white",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 16,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
    ...theme.applyStyles("dark", {
      color: theme.palette.grey[300],
    }),
  },
}));
const sortByOptions = [
  { key: 1, option: "Price: Low to High", slug: "priceLtoH" },
  { key: 2, option: "Price: High to Low", slug: "priceHtoL" },
  { key: 3, option: "Ratings: High to Low", slug: "ratingHtoL" },
];

export default function MobileSortWrapper({
  filterValues,
  setFilterValues,
  data,
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const bestSellerCount =
    (data && data.filter((item) => item?.product_tags?.best_selling === 1).length) || 0;
  const newArrivalCount =
    (data && data.filter((item) => item?.product_tags?.new_product === 1).length) || 0;

  let updatedSortByOptions = [...sortByOptions];

  if (bestSellerCount > 0) {
    updatedSortByOptions.push({ option: "Best Seller", slug: "bestSeller" });
  }
  if (newArrivalCount > 0) {
    updatedSortByOptions.push({ option: "New Arrival", slug: "newArrival" });
  }
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (option) => {
    if (option) {
      setFilterValues((prev) => ({
        ...prev,
        sortType: option,
      }));
    }
    setAnchorEl(null);
  };
  useEffect(() => {
    handleClose(filterValues?.sortType);
  }, [filterValues?.sortType]);
  const sortName = updatedSortByOptions.find(
    (item) => item.slug === filterValues?.sortType
  )?.option;

  const handleChange = (event) => {
    setFilterValues((prev) => ({
      ...prev,
      sortType: event.target.value,
    }));
  };
  return (
    <div>
      <FormControl sx={{ width: "100%", p: 2 }}>
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: "16px",
            color: "var(--neutral-black)",
            textAlign: "left",
            lineHeight: "150%",
            textTransform: "capitalize",
          }}
        >
          Sort By
        </Typography>
        <RadioGroup
          aria-labelledby="demo-controlled-radio-buttons-group"
          name="controlled-radio-buttons-group"
          value={filterValues?.sortType}
          onChange={handleChange}
        >
          {updatedSortByOptions.map((item, index) => (
            <FormControlLabel
              key={index}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                fontWeight: 500,
                fontSize: "12px",
                color: "var(--neutral-800)",
                mx: 0,
              }}
              value={item.slug}
              control={<Radio />}
              label={item.option}
              labelPlacement="start"
            />
          ))}
        </RadioGroup>
      </FormControl>
    </div>
  );
}
